import Component from '../../colorz/Component';

export default class FormSubmit extends Component {
	onInit() {
		const formSubmitEvent = {};
		formSubmitEvent.event = 'newsletter_subscribe';

		dataLayer.push(formSubmitEvent);
	}
}
